import { DropDownModel, DropDownWithLabelModel } from "./dropDown";

export enum PaymentMethodTypes {
    CASH = "CASH",
    CARD = "CARD",
    TRANSFER = "TRANSFER",
    PAYU = "PAYU",
    HIPRO_INSTALLMENTS = "HIPRO_INSTALLMENTS",
    PAY_BY_LINK = "PAY_BY_LINK"
}

export const PaymentMethodDropDown: DropDownModel[] = [
    {
        id: PaymentMethodTypes.TRANSFER,
        displayName: "Tradycyjny przelew"
    },
    {
        id: PaymentMethodTypes.CASH,
        displayName: "Płatność gotówką"
    },
    {
        id: PaymentMethodTypes.PAYU,
        displayName: "Płatność Online"
    }
];

export const DirectPaymentMethodDropDown: DropDownModel[] = [
    {
        id: PaymentMethodTypes.PAYU,
        displayName: "Płatność PayU"
    }
];

export const DistancePaymentMethodDropDown: DropDownModel[] = [
    {
        id: PaymentMethodTypes.TRANSFER,
        displayName: "Tradycyjny przelew"
    }
];

export function filterAllowedPaymnetMethods(paymentMethods: DropDownModel[], allowedPaymentMethods: PaymentMethodTypes[] | undefined): DropDownWithLabelModel {
    const selectedPaymentMethods = (!allowedPaymentMethods || allowedPaymentMethods.length === 0) ? paymentMethods : paymentMethods.filter(method => allowedPaymentMethods.includes(method.id as PaymentMethodTypes));
    return {
        label: "Forma płatności",
        dropDown: selectedPaymentMethods
    };
}

export function getValidPaymentMethod(paymentMethod: PaymentMethodTypes | undefined, allowedMethods: PaymentMethodTypes[] | undefined): PaymentMethodTypes {
    const method = paymentMethod ?? PaymentMethodTypes.TRANSFER;
    if (!!allowedMethods && allowedMethods.length) {
        return allowedMethods!.includes(method) ? method : allowedMethods[0];
    } else {
        return method;
    }
}

